import {Redirect, Route, Switch} from "react-router-dom";

import ChangePasswordProfile from "../../containers/ChangePasswordProfile/ChangePasswordProfile";
import Credits from "../../containers/Credits/Credits";
import Data from "../../containers/Data/Data";
import ProfileHeader from "../ProfileHeader/ProfileHeader";
import React, {useEffect, useState} from "react";
import TwoFactor from "../../containers/TwoFactor/TwoFactor";
import {handleSSOError, logout} from "../../store/actions";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import Loading from "../SSO/Loading";
import {axiosInstance} from "../../utils/util.axios";
import styles from "./Profile.module.scss";

const Profile = (props) => {
    const state = useSelector((state) => state.general);
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(true);
    const getKeycloakAccountUrl = async () => {
        try {
            const res = await axiosInstance.get("/auth_profile_url", { withCredentials: true });
            if (res.data.url) {
                setIsLoading(false);
                window.location.href = res.data.url;
            }
            setIsLoading(false);
            dispatch(handleSSOError("URL for profile isn't found"));
        } catch (error) {
            setIsLoading(false);
            dispatch(handleSSOError("Error fetching redirect URL for profile"));
            history.push("/register");
        }
    };

    useEffect(() => {
        if (state.isSSOEnabled) {
            getKeycloakAccountUrl();
        }
    }, [state.isSSOEnabled]);

    let url = props.match.url;
    const dispatch = useDispatch();

    if (state.isSSOEnabled) {
        return (
            <div className={styles.container}>
                {isLoading && <Loading />}
            </div>
        );
    }

    return (
        <div>
            <ProfileHeader/>
            <div>
                <Switch>
                    <Route path={url + "/logout"} render={() => {
                        dispatch(logout());
                    }} />
                    <Route path={url + "/data"} component={Data}  />
                    <Route path={url + "/change-password"} component={ChangePasswordProfile}/>
                    <Route path={url + "/factor-authenticator"} component={TwoFactor}/>
                    <Route path={url + "/credits"} component={Credits}/>
                    <Redirect from="/" to={url + "/data"}/>
                </Switch>
            </div>
        </div>

    );
};

export default Profile;
